"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _rxjs = require("rxjs");

var _operators = require("rxjs/operators");

var _EthereumApi = require("./EthereumApi");

class Synthetic {
  constructor(provider) {
    this.apiProvider = void 0;
    this.protocol = void 0;
    this.baseContracts = void 0;

    this.allowance = (account, token) => {
      const grantAddress = this.baseContracts.syntheticFlowProtocol.options.address;
      const contract = this.apiProvider.getTokenContract(token);
      return (0, _rxjs.from)(contract.methods.allowance(account, grantAddress).call());
    };

    this.grant = async (account, token, balance = _EthereumApi.UINT256_MAX) => {
      const grantAddress = this.baseContracts.syntheticFlowProtocol.options.address;
      const contract = this.apiProvider.getTokenContract(token);
      const extrinsic = contract.methods.approve(grantAddress, balance);
      return this.apiProvider.extrinsicHelper(extrinsic, {
        from: account
      }, {
        action: 'Grant'
      });
    };

    this.allPoolIds = () => {
      return (0, _rxjs.of)([this.protocol.addresses.syntheticPoolGeneral.toLowerCase(), this.protocol.addresses.syntheticPoolXYZ.toLowerCase()]);
    };

    this.redeem = async (account, poolId, fromToken, amount) => {
      const extrinsic = this.baseContracts.syntheticFlowProtocol.methods.redeem(fromToken, poolId, amount);
      return this.apiProvider.extrinsicHelper(extrinsic, {
        from: account
      }, {
        action: 'Swap'
      });
    };

    this.mint = async (account, poolId, toToken, amount) => {
      const extrinsic = this.baseContracts.syntheticFlowProtocol.methods.mint(toToken, poolId, amount);
      return this.apiProvider.extrinsicHelper(extrinsic, {
        from: account
      }, {
        action: 'Swap'
      });
    };

    this.apiProvider = provider;
    this.protocol = provider.protocol;
    this.baseContracts = provider.baseContracts;
  }

  depositLiquidity(account, poolId, amount) {
    const protocol = this.baseContracts.syntheticFlowProtocol;
    const extrinsic = protocol.methods.deposit(amount);
    return this.apiProvider.extrinsicHelper(extrinsic, {
      from: account
    }, {
      action: 'Deposit'
    });
  }

  withdrawLiquidity(account, poolId, amount) {
    const protocol = this.baseContracts.syntheticFlowProtocol;
    const extrinsic = protocol.methods.withdraw(amount);
    return this.apiProvider.extrinsicHelper(extrinsic, {
      from: account
    }, {
      action: 'Withdraw'
    });
  }

  poolInfo(poolId) {
    const poolInterface = this.apiProvider.getSyntheticPoolInterfaceContract(poolId);
    return this.apiProvider.currencies.tokens().pipe((0, _operators.switchMap)(async tokens => {
      const owner = await poolInterface.methods.owner().call();
      const getBalancePromise = this.apiProvider.baseTokenContracts.methods.balanceOf(owner).call();
      const enabledTokens = await Promise.all(tokens.map(token => poolInterface.methods.allowedTokens(token.id).call().then(enabled => [token, enabled]))).then(results => results.filter(([, enabled]) => enabled).map(([token]) => token));
      const options = await Promise.all(enabledTokens.map(token => Promise.all([poolInterface.methods.getAdditionalCollateralRatio(token.id).call(), poolInterface.methods.getAskSpread(token.id).call(), poolInterface.methods.getBidSpread(token.id).call()]).then(([additionalCollateralRatio, askSpread, bidSpread]) => ({
        tokenId: token.id,
        additionalCollateralRatio,
        askSpread,
        bidSpread
      }))));
      return {
        poolId: poolInterface.options.address.toLowerCase(),
        owner: owner,
        balance: await getBalancePromise,
        options
      };
    }));
  }

}

var _default = Synthetic;
exports.default = _default;